import { render, staticRenderFns } from "./AppMenuItem.vue?vue&type=template&id=15a42f9b&"
import script from "./AppMenuItem.vue?vue&type=script&lang=js&"
export * from "./AppMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports